export default function($http, $timeout) {
  "ngInject";

  const _ = require("underscore")._;

  let survey = {};
  let surveyKey;
  let inviteCodeMetadata = null;
  const warnings = new Set();
  let gInviteCode;
  let lastSave = null;
  let timer = null;
  let timerwait = false;
  let saveError = false;
  let saveErrorCleared = false;
  let saveHandler = false;
  const languages = [ 
    {
      key: "eng",
      name: "English",
    },
    {
      key: "spa",
      name: "Spanish",
    },
    {
      key: "fre",
      name: "French",
    },
    {
      key: "hat",
      name: "Haitian Creole",
    },
  ];

  function getSurveyConfig(inviteCode) {
    gInviteCode = inviteCode;
    return $http({
      method: "GET",
      url: `surveys/${surveyKey}.json`,
    }).then(
      res => {
       const survey = res.data;
        if (inviteCode) {
          return $http({
            method: "GET",
            url: `api/surveys/${survey.id}/invite-codes/${inviteCode}`,
          }).then(res => {

            //original invite code result data
            const inviteData = res.data;

            //look for saved survey progress
            return $http({
              method: 'GET',
              url: `api/surveys/${survey.id}/saved-invite/${inviteCode}`,
            }).then(res => {
              const savedSurveyProgress = res.data;

              return {
                saved: savedSurveyProgress,
                survey,
                inviteCodeMetadata: inviteData.data,
              };

            }).catch(res => {
              //any error (not found included) return original invite code data
              return {
                survey,
                inviteCodeMetadata: inviteData.data,
              };
            })
          });
        } else {
          return {
            survey,
          };
        }
      },
      err => {
        return null;
      }
    );
  }

  function postSurveyResponse(data) {
    return $http({
      method: "POST",
      url: `api/record-survey-response/${survey.id}`,
      data,
    });
  }

  function setInviteCodeStatusToViewed(inviteCode) {
    return $http({
      method: "PUT",
      url: `api/surveys/${survey.id}/invite-codes/${inviteCode}/viewed`,
    });
  }

  function guidGenerator() {
    const s4 = function() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
  }

  function isGrid(sectionType) {
    return /^.*_GRID$/.test(sectionType);
  }

  function answerOptions(section) {
    if (section.type !== "EFFECTIVE_5_GRID" && section.type !== "RATE_5_GRID") {
      return section.options.length - 1;
    } else {
      return section.options.length;
    }
  }

  function testConditional(sections, object) {
    //only hide the question if it is actually answered from the metadat rather than answered in
    if (object.forceMetadataAnswer && inviteCodeMetadata && object.answer.optionId && inviteCodeMetadata.customFields[object.answer.metadataKey]) {
      return false;
    }
    
    const conditional = object.conditional;
    if (typeof conditional !== "undefined") {
      const section = _.find(sections, function(section) {
        return section.id === conditional.sectionId;
      });
      if (section) {
        if (isGrid(section.type)) {
          const optionIndex = _.object(
            _.map(section.options, function(option, index) {
              return [option.id, index];
            })
          );
          const questionsAnswered = {};
          for (let i = 0; i < section.questions.length; i++) {
            const question = section.questions[i];
            questionsAnswered[question.id] =
              question.answer &&
              question.answer.optionId &&
              optionIndex[question.answer.optionId] < answerOptions(section);
          }
          if (typeof conditional.optionId === "string") {
            return questionsAnswered[conditional.optionId];
          } else if (typeof conditional.optionId.$in !== "undefined") {
            for (let i = 0; i < conditional.optionId.$in.length; i++) {
              if (questionsAnswered[conditional.optionId.$in[i]]) {
                return true;
              }
            }
            return false;
          } else if (typeof conditional.optionId.$nin !== "undefined") {
            for (let i = 0; i < conditional.optionId.$nin.length; i++) {
              if (questionsAnswered[conditional.optionId.$nin[i]]) {
                return false;
              }
            }
            return true;
          }
        } else {
          if (typeof conditional.optionId === "string") {
            return section.answer !== null && section.answer.optionId === conditional.optionId;
          } else if (typeof conditional.optionId.$in !== "undefined") {
            return section.answer !== null && conditional.optionId.$in.indexOf(section.answer.optionId) !== -1;
          } else if (typeof conditional.optionId.$nin !== "undefined") {
            return section.answer !== null && conditional.optionId.$nin.indexOf(section.answer.optionId) === -1;
          }
        }
      } else {
        const message = `Looks like a show/hide rule is broken: ${object.title.eng}`;
        if (!warnings.has(message)) {
          warnings.add(message);
          console.warn(message);
        }
        return false;
      }
    } else {
      return true;
    }
  }

  return {
    init(surveyKeyIn, inviteCode, languageKey) {
      if (!surveyKey) {
        surveyKey = surveyKeyIn;
        return Promise.all([getSurveyConfig(inviteCode)]).then(res => {
          const tempSurvey = [];
          if (res[0] !== null) {
            for (let i in res[0].survey.sections) {
              const section = res[0].survey.sections[i];

              if (section.type === "MULTIPLE_CHOICE" && section.sortOptions) {
                section.options = _.sortBy(section.options, function(option) {
                  if (option.value[languageKey]) {
                    return option.value[languageKey].toLowerCase();
                  }
                  return undefined;
                });
              }

              if (res[0].inviteCodeMetadata) {
                if (section.title) {
                  for (let i in languages) {
                    if (section.title[languages[i].key]) {
                      for (let metadataKey in res[0].inviteCodeMetadata.customFields) {
                        const metadataValue = res[0].inviteCodeMetadata.customFields[metadataKey];
                        section.title[languages[i].key] = section.title[languages[i].key].replace(
                          `[${metadataKey}]`,
                          metadataValue
                        );
                      }
                    }
                  }
                }
                if (section.type === "MULTIPLE_CHOICE") {
                  if (section.answer.metadataKey) {
                    const metadataValue = res[0].inviteCodeMetadata.customFields[section.answer.metadataKey];
                    const option = _.find(section.options, function(option) {
                      return option.value.eng === metadataValue;
                    });
                    if (option) {
                      section.answer.optionId = option.id;
                    }
                  }
                }
              }

              if (!res[0].inviteCodeMetadata) {
                if (section.type === "TEXT" && section.title) {
                  let invalid = false;
                  for (let i in languages) {
                    if (section.title[languages[i].key] && /\[.*\]/.test(section.title[languages[i].key])) {
                      invalid = true;
                    }
                  }
                  if (!invalid) {
                    tempSurvey.push(res[0].survey.sections[i]);
                  }
                } else {
                  tempSurvey.push(res[0].survey.sections[i]);
                }
              }
            }

            if (!res[0].inviteCodeMetadata) {
              res[0].survey.sections = tempSurvey;
            }

            survey = res[0].survey;
            inviteCodeMetadata = res[0].inviteCodeMetadata;

            //use the saved survey if it was part of the response
            if (res[0].saved) {
              let saved = res[0].saved;

              //if the section has an answer, look up and use it if found
              survey.sections = survey.sections.map(section => {
                  //find the saved section by id
                  const saved_section = _.find(saved.sections, s => s.id === section.id);

                  //early return if we don't have any saved section to load
                  if (!saved_section) return section;

                  //set the saved answer for sections with a single answer
                  if (section.answer && saved_section.answer) section.answer = saved_section.answer;

                  //set the questions answers (likert grids)
                  if (section.questions) {
                    section.questions = section.questions.map( q => {
                      const saved_question = _.find(saved_section.questions, sq => sq.id === q.id);
                      if (saved_question) q.answer = saved_question.answer;
                      return q;
                    })
                  }

                  //set the options.checked values for checkbox list selections
                  if (section.options) {
                    section.options = section.options.map( o => {
                      //look up option in saved section to find if it was checked and set
                      const savedChecked = _.find(saved_section.options, so => so.id === o.id);
                      if (savedChecked && savedChecked.checked) o.checked = true;
                      return o;
                    })
                  }

                  return section;

              });
                
            }
          }

          return res;
        });
      } else {
        return Promise.resolve([survey, inviteCodeMetadata]);
      }
    },

    getSurvey() {
      return survey;
    },

    getSaveError() {
      return !saveErrorCleared && saveError;
    },

    clearSaveError() {
      saveError = false;
      saveErrorCleared = true; //don't show twice
    },

    login(password, global=false) {
      return $http({
        method: "POST",
        url: global ? `/api/surveys/invite-login` : `/api/surveys/${survey.id}/invite-login`,
        data: JSON.stringify({ password })
      }).then( (res) => {
        window.location = `/s/${res.data.surveyKey || surveyKey}?i=${res.data.inviteCode}`;
        return true;
      }, (err) => {
        return false;
      });
    },

    saveSurveyProgress() {
      if (!gInviteCode) return;

      //use optional interval from survey config
      const autoSaveInterval = survey.autoSaveInterval || 15000;

      const now = new Date().valueOf();

      //save every 30 seconds
      if (lastSave !== null && now - lastSave < autoSaveInterval) {

        if (!timerwait) {
          //start a new timer
          timerwait = true; 

          //setup timeout
          timer = $timeout(() => {
            timerwait = false; //done, cancel 
            this.saveSurveyProgress();
          },now-lastSave+50); //add 50 ms delay
        }

        return;
      }

      //we can get here during the 50ms delay above. just cancel the timer and save regular
      if (timerwait) {
        timerwait = false;
        $timeout.cancel(timer);
      }

      //update our last save
      lastSave = now;

      //cleanup the save record
      const survey_progress = {
        sections: survey.sections.map(s => {

          var result = {
            id: s.id
          };

          if (s.answer)
            result.answer = s.answer;

          if (s.options)
            result.options = s.options.map(o => ({
              id: o.id,
              answer: o.answer,
              checked: o.checked
            }));

          if (s.questions)
            result.questions = s.questions.map(q => ({
              id: q.id,
              answer: q.answer
            }))

          return result;
            
          })
      }

    
      //persist the record
      try {
        return $http({
          method: "POST",
          url: `/api/save-survey-response/${survey.id}/${gInviteCode}`,
          data: survey_progress
        }).then( (res) => {

          saveError = res.data.error === "old_data";

          if (!saveError) {
            //toggle the saving message
            document.getElementById('saving-message').classList.add('active');
            $timeout(() => document.getElementById('saving-message').classList.remove('active'), 3000);
          }

        })
      }catch (ex) {
        console.log("Error saving progress " + ex);
      }
  
    },

    recordSurveyResponse(data) {
      return postSurveyResponse(data);
    },

    getMetadata() {
      return inviteCodeMetadata;
    },

    viewedSurvey() {
      setInviteCodeStatusToViewed(inviteCodeMetadata.inviteCode);
    },

    toggleGridAnswer(sectionId, questionId, optionId) {
      const section = _.find(survey.sections, function(section) {
        return section.id === sectionId;
      });
      const question = _.find(section.questions, function(question) {
        return question.id === questionId;
      });
      if (question.answer !== null && question.answer.optionId === optionId) {
        question.answer.optionId = null;
      } else {
        question.answer.optionId = optionId;
      }
      
      this.saveSurveyProgress();
    },

    toggleAnswer(sectionId, optionId) {
      const section = _.find(survey.sections, function(section) {
        return section.id === sectionId;
      });
      if (section.answer !== null && section.answer.optionId === optionId) {
        section.answer.optionId = null;
      } else {
        section.answer.optionId = optionId;
      }

      this.saveSurveyProgress();
    },

    toggleCheck() {
      this.saveSurveyProgress();
    },

    selectAnswer(sectionId, optionId) {
      const section = _.find(survey.sections, function(section) {
        return section.id === sectionId;
      });
      const option = _.find(section.options, function(option) {
        return option.id === optionId;
      });
      section.answer.optionId = option.id;
    },

    isConditionalMet(section) {
      return testConditional(survey.sections, section);
    },

    getTitle(object) {
      const alternateTitle = _.find(object.alternateTitles, function(alternateTitle) {
        return testConditional(survey.sections, alternateTitle);
      });
      if (alternateTitle) {
        return alternateTitle.title;
      } else {
        return object.title;
      }
    },

    getLanguageKeys() {
      return _.pluck(languages, "key");
    },

    getGuid() {
      return guidGenerator();
    },
  };
}



// WEBPACK FOOTER //
// ./app/components/survey-service.js